import { Getters } from 'vuex-smart-module';
import { ReasonsCommunicationState } from './state';

export default class ReasonsCommunicationGetters extends Getters<ReasonsCommunicationState> {}
